import React, { useEffect, useState } from "react";
import "./Annadanam_Content.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import { Form } from "react-bootstrap";
import Orange_Btn from "../../common/common_btn/orange_btn/Orange_Btn";
import { useDispatch } from "react-redux";
import { CreateUserDonationDetails, setDonationStep1Data } from "../../../features/admin/user_donation_details/Slice";
import { useForm } from "react-hook-form";
import { useContext } from "react";
import { Context } from "../../../utils/context";
import Login_Layout_Modal from "../../common/modals/login-signup-modals/Login_Layout_Modal";
import { useNavigate } from 'react-router-dom';
import { toWords } from "number-to-words";
import { encodeId, formatAmount } from "../../../utils/common";

const Annadanam_Content = ({ currentData }) => {
  const dispatch = useDispatch();
const navigate = useNavigate();

const [modelType, setModelType] = useState("");
const [selectLogin, setSelectLogin] = useState(false);


  const [selected, setSelected] = useState([]); 
  const [selectedPrice, setSelectedPrice] = useState(null);

  const { register, watch, setValue, formState:{errors} } = useForm();
  const manualAmount = watch("price");

  const numberToWords = (num) => {
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

  if (num === 0) return "Zero";

  let words = "";

  if (num >= 1000) {
    words += ones[Math.floor(num / 1000)] + " Thousand ";
    num %= 1000;
  }
  if (num >= 100) {
    words += ones[Math.floor(num / 100)] + " Hundred ";
    num %= 100;
  }
  if (num >= 20) {
    words += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  } else if (num >= 10) {
    words += teens[num - 10] + " ";
    return words;
  }
  if (num > 0) {
    words += ones[num] + " ";
  }
  return words.trim();
};


const MAX_AMOUNT = 100000000; 

const finalAmount =
  manualAmount && Number(manualAmount) > 0
    ? Number(manualAmount)
    : selectedPrice && Number(selectedPrice) > 0
    ? Number(selectedPrice)
    : 0;

let finalAmountInWords = "No Amount Selected";

if (
  Number.isFinite(finalAmount) &&
  finalAmount > 0 &&
  finalAmount <= MAX_AMOUNT
) {
  finalAmountInWords = `Rupees ${toWords(finalAmount)} Only`;
} else if (finalAmount > MAX_AMOUNT) {
  finalAmountInWords = "Amount exceeds allowed limit";
}

  const handleSelect = (label, price) => {
    setSelected([label]); 
    setSelectedPrice(price);  
    setValue("price", "");
  };

  useEffect(() => {
    if (manualAmount && manualAmount > 0) {
      setSelected([]);
      setSelectedPrice(null);
    }
  }, [manualAmount]);

  

  
const onContinue = () => {
  const formData={
  donation_id : currentData?.id
  }
   let paymentAmount = null;
    if (manualAmount && manualAmount > 0) {
      paymentAmount = manualAmount;
    } else if (selectedPrice) {
      paymentAmount = selectedPrice;
    } else {
      alert("Please select a donation plan or enter an amount to continue");
      return;
    }
    
    if(paymentAmount > MAX_AMOUNT){
      alert(`Amount Limit is ${MAX_AMOUNT}`);
      return;
    }
    formData.paymentAmount = paymentAmount;

  dispatch(setDonationStep1Data(formData));
  navigate(`/donation-step-2/${encodeId(currentData?.id)}?amount=${paymentAmount}`);
};


  return (
    <section className="Annadanam_Content">
      <div className="container">
        <div className="main_div">
          <Common_Title_2 subText="Step 1 of 2: Donation" />

          <p className="section_heading">I would like to donate</p>

          <div className="all_cards_holder">
            <div className="row">
              {currentData?.Donation_Plans?.map((item) => {
                const isActive = selected.includes(item?.planname);

                return (
                  <div key={item?.planname} className="col-lg-3 col-md-4 col-6 mb-3">
                    <div
                      className={`donation_card ${isActive ? "active" : ""}`}
                      onClick={() => handleSelect(item?.planname, item?.price)}
                    >
                      <div className="inner_card">
                        <div className="checkbox_div">

                          <Form.Check
                            type="checkbox"
                            id={item?.planname}
                            checked={isActive}
                            onChange={() => handleSelect(item?.planname, item?.price)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                         <div className="info_div">
                           <div className="title_box">
                             <p className="label_text">{item?.planname}</p>
                           </div>
                           <p className="amount_text">{formatAmount( item?.price)}</p>
                         </div>
                      </div>
                      <div className="overlay"></div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="or_div">
            <p className="text">OR</p>
          </div>
        </div>
      </div>

      <div className="full_container_div">
        <div className="left_div">
          <img src="/assets/images/event_registration/near_you/right.png" className="left_img" />
        </div>

        <div className="right_div">
          <img src="/assets/images/event_registration/near_you/left.png" className="right_img" />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="gray_box">
                <div className="input_box">
                  <Form.Label className="label_text">
                    Enter Other Amount:
                  </Form.Label>
                                       <Form.Control
                    type="text"
                    name="price"
                    placeholder="Enter Amount"
                  
                    {...register("price", {
                      required: "Enter Amount is required",
                    })}
                    onKeyDown={(e) => {
                      // Allow left and right arrows and backspace
                      if (
                        e.key === "ArrowLeft" ||
                        e.key === "ArrowRight" ||
                        e.key === "Backspace"
                      ) {
                        return;
                      }

                      // Allow only numbers
                      if (!/[\d]/.test(e.key)) {
                        e.preventDefault(); // Prevent non-numeric input
                      }
                    }}
                  />
                    {errors?.price && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.price?.message}
                      </div>
                    )}

                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="contri_amount_div">
                <div className="left_icon_div">
                  <img src="/assets/images/annadanam/Deposit.png" className="contri_img" />
                </div>
                <div className="text_div">
                <p className="text">Your contribution amount:  {formatAmount(finalAmount)}</p>
              <p className="amount_text">{finalAmountInWords}</p>

                </div>
              </div>
            </div>
          </div>

          <div className="btn_holder">
            {/* <Orange_Btn btnText={"Continue"} onClick={openRazorpay} /> */}
            {/* <Orange_Btn
            btnText={"Continue"}
            onClick={() => navigate("/donation-step-2")}
            /> */}
            <Orange_Btn
            btnText="Continue"
            onClick={() => onContinue()}
          />
          </div>



          <p className="footer_text">
           Every contribution, whether big or small, creates a ripple effect, fostering positive change & opening doors to new possibilities for individuals and communities alike.
          </p>
          <p className="footer_text">
          It's through your generosity that hope is ignited, challenges are overcome, and brighter futures are built.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Annadanam_Content;







// import React, { useEffect, useState } from "react";
// import "./Annadanam_Content.css";
// import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
// import { Form } from "react-bootstrap";
// import Orange_Btn from "../../common/common_btn/orange_btn/Orange_Btn";
// import { useDispatch, useSelector } from "react-redux";
// const Annadanam_Content = ({currentData}) => {

//   console.log("currentData?.Donation_PlanscurrentData?.Donation_PlanscurrentData?.Donation_Plans",currentData?.Donation_Plans)
//     const dispatch = useDispatch();

//   const [selected, setSelected] = useState([]);

//   const handleSelect = (label) => {
//     setSelected((prev) =>
//       prev.includes(label)
//         ? prev.filter((item) => item !== label)
//         : [...prev, label]
//     );
//   };

//  useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);



//   const vendorSubscriptionfun = async (razorpay_payment_id) => {
//     const data = {
      
//     }

//     console.log("data", data);

//     // const res=await dispatch(vendorSubscription(data));
//   };



//   const openRazorpay = () => {
//     const amountInPaise = 1 * 100;

//     const options = {
//       key: "rzp_test_I05KCFb1v5JJRc",
//       amount: amountInPaise,
//       currency: "INR",
//       name: "My MDS",
//       description: "Test Transaction",
//       image: "/assets/images/logo/logo.png",
//       handler: function (response) {
//         vendorSubscriptionfun(response.razorpay_payment_id)
//         console.log("Payment Successful!", response);
//         alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
//         // nextStep();
//       },
//       prefill: {
//         name: "Test User",
//         email: "testuser@example.com",
//         contact: "9999999999",
//       },
//       notes: {
//         address: "Razorpay Corporate Office",
//       },
//       theme: {
//         color: "#052c65",
//       },
//     };

//     const rzp1 = new window.Razorpay(options);
//     rzp1.open();

//     rzp1.on("payment.failed", function (response) {
//       console.error("Payment Failed:", response.error);
//       alert("Payment failed. Please try again.");
//     });
//   };




//   return (
//     <section className="Annadanam_Content">
//       <div className="container">
//         <div className="main_div">
//           <Common_Title_2 subText="Step 1 of 2: Donation" />

//           <p className="section_heading">I would like to donate</p>

//           <div className="all_cards_holder">
//             <div className="row">
//               {currentData?.Donation_Plans?.map((item) => {
//                 const isActive = selected.includes(item?.planname);

//                 return (
//                   <div key={item?.label} className="col-lg-3 col-md-4 col-6 mb-3">
//                     <div
//                       className={`donation_card ${isActive ? "active" : ""}`}
//                       onClick={() => handleSelect(item?.planname)} // ✅ clicking anywhere toggles
//                     >
//                       <div className="inner_card">
//                         <div className="checkbox_div">
//                           <Form.Check
//                             type="checkbox"
//                             id={item?.planname}
//                             checked={isActive}
//                             onChange={() => handleSelect(item?.planname)} // still works
//                             onClick={(e) => e.stopPropagation()} // ✅ prevent double toggle when clicking checkbox directly
//                           />
//                         </div>
//                         <div className="info_div">
//                           <div className="title_box">
//                             <p className="label_text">{item?.planname}</p>
//                           </div>
//                           <p className="amount_text">{item?.price}</p>
//                         </div>
//                       </div>
//                       <div className="overlay"></div>
//                     </div>
//                   </div>
//                 );
//               })}

//             </div>
//           </div>

//           <div className="or_div">
//             <p className="text">OR</p>
//           </div>
//         </div>
//       </div>

//       <div className="full_container_div">
//         <div className="left_div">
//           <img
//             src="/assets/images/event_registration/near_you/right.png"
//             className="left_img"
//           />
//         </div>

//         <div className="right_div">
//           <img
//             src="/assets/images/event_registration/near_you/left.png"
//             className="right_img"
//           />
//         </div>

//         <div className="container">
//           <div className="row">
//             <div className="col-md-6">

//               <div className="gray_box">
//                 <div className="input_box">
//                   <Form.Label className="label_text">
//                     Enter Other Amount:
//                   </Form.Label>
//                   <Form.Control
//                     type="number"
//                     name="First_Name"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6">

//               <div className="contri_amount_div">
//                 <div className="left_icon_div">
//                   <img
//                     src="/assets/images/annadanam/Deposit.png"
//                     className="contri_img"
//                   />
//                 </div>
//                 <div className="text_div">
//                   <p className="text">Your contribution amount:</p>
//                   <p className="amount_text">Rupees Seven Hundred Only</p>
//                 </div>
//               </div>
//             </div>
//           </div>


//           <div className="btn_holder">
//             <Orange_Btn btnText={"Continue"}  onClick={openRazorpay} />
//           </div>

//           <p className="footer_text">
//             Every contribution, whether big or small, creates a ripple effect,
//             fostering positive change & opening doors to new possibilities for
//             individuals and communities alike.
//           </p>

//           <p className="footer_text">
//             It's through your generosity that hope is ignited, challenges are
//             overcome, and brighter futures are built.
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Annadanam_Content;
